export const inputClass =
  "border-stroke focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary w-full rounded border-[1.5px] bg-transparent px-2 py-2 text-xs font-semibold text-gray-900 outline-none transition dark:text-white";

export const labelClass =
  "mb-1 ml-1 block text-xs font-bold text-gray-900 dark:text-white";

export const errorMessageClass =
  "border-red-500 focus:border-red-500 active:border-red-500 disabled:bg-whiter dark:border-red-500 dark:bg-form-input w-full rounded border-[1.5px] bg-transparent px-2 py-1.5 text-xs font-normal text-black outline-none transition disabled:cursor-default dark:text-white";
